import { Outlet } from 'react-router';

import { SoftwareEscrowContextProvider } from 'src/context/software-escrow';

const SoftwareEscrowLayout = () => {
  return (
    <SoftwareEscrowContextProvider>
      <Outlet />
    </SoftwareEscrowContextProvider>
  );
};

export default SoftwareEscrowLayout;
